import React from 'react';
import { useSelector } from 'react-redux';
import { setLocalStorage } from '../../../../../helpers/helpersMeshBot';

import classNames from 'classnames';
import { MeshBotLabelsInTableCell } from '../../../../../features/Labels/MeshBotsLabels';
import { getMeshBotDropZoneAttributes } from '../../utils';
import withAbilityGoEditMeshbot from '../../HOCs/withAbilityGoEditMeshbot';

import styles from './MeshBotNameCell.module.scss';
import { shouldDisableSystemTcdsActions } from 'containers/Ezlo/EzloMeshbot/utils';
import { ADVANCED_SCENES } from 'constants/ControllerFeatures';
import { EZLOGIC_TITLE_EDIT_MESHBOT_FROM_ADVANCED_SCENE_1_74 } from 'constants/language_tokens';
import { Tooltip } from 'components';
import { useTranslate } from 'features/languages';

const MeshBotNameCell = ({ row: { original: params }, onClick }) => {
    const { t } = useTranslate();
    const ezloData = useSelector((state) => state.ezlo?.data?.[params?.serial]);
    const isTcdsDisabled = shouldDisableSystemTcdsActions(params, ezloData, ADVANCED_SCENES.VERSION_1_74);
    // TODO: refactoring needed, legacy approach, no localstorage here!
    const handleClick = () => {
        if (!params.isAllowedToManageMeshBots || !params.isMeshBotEditingEnabled) {
            return;
        }
        setLocalStorage('createType', params.type);
        onClick(params);
    };

    return (
        <Tooltip
            title={
                isTcdsDisabled ? (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t(EZLOGIC_TITLE_EDIT_MESHBOT_FROM_ADVANCED_SCENE_1_74),
                        }}
                    />
                ) : (
                    ''
                )
            }
            position="top"
        >
            <span>
                <div
                    {...getMeshBotDropZoneAttributes(params)}
                    onClick={handleClick}
                    title={params.name}
                    className={classNames(styles.cell, {
                        [styles.disabled]: params.isDisabled || isTcdsDisabled,
                        [styles.nonePointerEvents]:
                            !params.isAllowedToManageMeshBots || !params.isMeshBotEditingEnabled,
                    })}
                >
                    <MeshBotLabelsInTableCell labelsUuids={params.labelsUuids} meshBotUuid={params.id} />
                    <span className={styles.name}>{params.name}</span>
                </div>
            </span>
        </Tooltip>
    );
};

export default withAbilityGoEditMeshbot(MeshBotNameCell);
